import { Component, Input, OnInit } from '@angular/core';
import { UserService } from 'src/app/shared/services/user.service';

interface IAdminNavItem {
  label: string;
  route: string;
  visible: boolean;
  children?: IAdminNavItem[];
  expanded?: boolean;
}

@Component({
  selector: 'app-admin-sidebar-menu',
  templateUrl: './admin-sidebar-menu.component.html',
  styleUrls: ['./admin-sidebar-menu.component.scss'],
})
export class AdminSidebarMenuComponent implements OnInit {
  @Input() isSidebarExpanded: boolean = false;

  menuItems: IAdminNavItem[] = [];
  isSubTenant: boolean = false;
  isSuperTenant: boolean = false;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.isSubTenant = this.userService.isSubTenant;
    this.isSuperTenant = this.userService.isSuperTenant;
    this.menuItems = this.getMenuItems();
  }

  getMenuItems(): IAdminNavItem[] {
    return [
      {
        label: 'General',
        route: '/secure/admin/general-setup',
        visible: true,
      },
      {
        label: 'Tenants',
        route: '/secure/admin/tenant-summary',
        visible: this.isSuperTenant,
      },
      {
        label: 'Cleanup',
        route: '/secure/admin/cleanup-tenant',
        visible: this.isSuperTenant,
      },
      {
        label: 'Info',
        route: '/secure/admin/info-summary',
        visible: this.isSuperTenant,
      },
      {
        label: 'Batch Status',
        route: '/secure/admin/batch-status',
        visible: this.isSuperTenant,
      },
      {
        label: 'Batch Trigger',
        route: '/secure/admin/batch-trigger',
        visible: this.isSuperTenant,
      },
      {
        label: 'Originators',
        route: '/secure/admin/originators-summary',
        visible: !this.isSubTenant && !this.isSuperTenant,
      },
      {
        label: 'Index Setup',
        route: '/secure/admin/index-setup',
        visible: !this.isSubTenant && !this.isSuperTenant,
      },
      {
        label: 'Financing Sources',
        route: '/secure/admin/financing-sources',
        visible: !this.isSubTenant && !this.isSuperTenant,
      },
      {
        label: 'Investors',
        route: '/secure/admin/investor-summary',
        visible: !this.isSubTenant && !this.isSuperTenant,
      },
      {
        label: 'Wire Recipients',
        route: '/secure/admin/wire-recipient-summary',
        visible: !this.isSubTenant && !this.isSuperTenant,
      },
      {
        label: 'Templates',
        route: '/secure/admin/templates',
        visible: !this.isSubTenant && !this.isSuperTenant,
      },
      {
        label: 'Conditions',
        route: '/secure/admin/conditions',
        visible: !this.isSubTenant && !this.isSuperTenant,
      },
      {
        label: 'Agility Connect',
        route: '',
        visible: !this.isSubTenant && !this.isSuperTenant,
        expanded: true,
        children: [
          {
            label: 'Shipping',
            route: '/secure/admin/shipping',
            visible: true,
          },
          {
            label: 'Wire Recipient Verification',
            route: '/secure/admin/wire-recipient-verification',
            visible: true,
          },
        ],
      },
    ];
  }
}
